import React from "react";
import CardLayout from "../../../layouts/CardLayout";
import { SkuContainer } from "..";
import AuctionSheetView from "../AuctionSheetView";
import PhotoGallery, { PhotoGallerySkeleton } from "../../../ui/PhotoGallery";
import { TitleContainer } from "../../MoneyReceiptView";
import Skeleton from "react-loading-skeleton";

export default function VehicleImages({ data }) {
  return (
    <CardLayout>
      <TitleContainer>{data?.title ?? ""}</TitleContainer>
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-3">
        <SkuContainer className="m-0">SKU #{data?.sku ?? ""}</SkuContainer>

        {data?.auction_sheet?.length ? <AuctionSheetView url={data?.auction_sheet[0]} /> : ""}
      </div>

      <PhotoGallery data={data?.images} />
    </CardLayout>
  );
}

// VehicleImages skeleton
export function VehicleImagesSkeleton() {
  return (
    <CardLayout>
      <TitleContainer>
        <Skeleton width={`30%`} />
      </TitleContainer>

      <PhotoGallerySkeleton />
    </CardLayout>
  );
}
